(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BBPSSettingsEditController', BBPSSettingsEditController);

    BBPSSettingsEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService', '$uibModalInstance', 'BBPSSettings', 'entity', 'StaticLookUp', 'DateUtils'];

    function BBPSSettingsEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, BBPSSettings, entity, StaticLookUp, DateUtils) {
        var vm = this;
        vm.bbpsSetting = entity;

        vm.clear = clear;
        vm.save = save;
        vm.clicked = false;
        $scope.showButton = false;
        vm.resubmitBBPSSettings = resubmitBBPSSettings;
        vm.globalValues = GlobalValues;
        vm.markupType = { value: 'Paise' };
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.currentBusinessDate = vm.globalValues.getSystemSettings().businessDate;
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.effectiveFromDateTime = DateUtils.convertLocalDateFromServer(vm.currentBusinessDate);
        vm.todayDate = new Date();

        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        var now = moment();
        vm.momentBusinessDate = moment(vm.currentBusinessDate, 'YYYY-MM-DD');
        vm.momentBusinessDate.set(
            {
                'hour': now.get('hour'),
                'minute': now.get('minute'),
                'second': now.get('second')

            });
        vm.effectiveFromDateTime = vm.momentBusinessDate.toDate();

        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();

        vm.todayDate = new Date();
        $scope.$watch('vm.bbpsSetting.markupValue', function (value) {
            if (value == null || value == undefined || value == "") {

                document.getElementById("txtTaxOnMarkup").value = "";
                vm.bbpsSetting.taxOnMarkup = null;
            }
        });

        if (workflowSharedService.viewFrom == 'ManageBBPSSettings') {
            vm.bbpsSetting = entity;

            if (vm.bbpsSetting != null && vm.bbpsSetting != undefined) {
                vm.branch = vm.bbpsSetting.branch;
                vm.bank = vm.bbpsSetting.bank;
            }
            if (vm.entityOwnerType == 'Bank') {
                vm.bank = vm.globalValues.getBank();
            }

       	 	  $scope.showButton=false;
               vm.isModifyScreen = true;
        }
        else if (workflowSharedService.viewFrom == 'bbps_settingtodolist_resubmit') {
            vm.bbpsSetting = angular.fromJson($rootScope.payload);
            vm.bank = vm.bbpsSetting.bank;
            vm.branch = vm.bbpsSetting.branch;

        	vm.disableForm = false;
        	$scope.showButton=true;
            vm.isModifyScreen = true;
        }
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.bbpsSetting.bank = vm.bank;
            vm.bbpsSetting.branch = vm.branch;

            if (vm.bbpsSetting.id != null) {
                BBPSSettings.update({
                    "orgId": GlobalValues.getOrgId()
                }, vm.bbpsSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }


        function onSaveError() {

            vm.clicked = false;
        }
        function resubmitBBPSSettings() {
            vm.bbpsSetting.bank = vm.bank;
            vm.bbpsSetting.branch = vm.branch;

            BBPSSettings.resubmit({ "taskId": $rootScope.taskID }, vm.bbpsSetting, onResubmitSuccess, onResubmitError);


            $uibModalInstance.dismiss('cancel');
        }

        function onResubmitSuccess(result) {
            $rootScope.removeRow($rootScope.taskID);
        }
        function onResubmitError(error) { }


    }
})();
